import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function WhyChooseUs() {
  const { language } = useLanguage();
  const t = translations[language].whyChooseUs;

  const advantages = [
    {
      tagColor: 'bg-orange-100 text-[#FF6B35]',
      image: 'https://static.readdy.ai/image/48dde99e8fd8a26df059daa5a847ba45/49267b75ad0268406230e6f09123732e.png',
      imagePosition: 'right' as const
    },
    {
      tagColor: 'bg-blue-100 text-[#00A3FF]',
      image: 'https://static.readdy.ai/image/48dde99e8fd8a26df059daa5a847ba45/6613378bd88250631de738ea84ceae38.jpeg',
      imagePosition: 'left' as const
    },
    {
      tagColor: 'bg-purple-100 text-[#6B46C1]',
      image: 'https://public.readdy.ai/ai/img_res/503fb7793065bc8a71cdb9ae2de23763.jpg',
      imagePosition: 'right' as const
    },
    {
      tagColor: 'bg-orange-100 text-[#FF6B35]',
      image: 'https://readdy.ai/api/search-image?query=scalable%20IT%20infrastructure%203D%20visualization%20showing%20modular%20expandable%20architecture%20future-proof%20design%20with%20growth%20capacity%20network%20expansion%20concept%20professional%20technical%20illustration%20clean%20modern&width=600&height=700&seq=why-img-004&orientation=portrait',
      imagePosition: 'left' as const
    }
  ];

  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Advantages */}
        <div className="space-y-24">
          {t.advantages.map((advantage, index) => (
            <div
              key={index}
              className={`grid md:grid-cols-2 gap-12 items-center ${
                advantages[index].imagePosition === 'left' ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* Text Content */}
              <div className={advantages[index].imagePosition === 'left' ? 'md:order-2' : ''}>
                <span className={`inline-block px-4 py-1.5 ${advantages[index].tagColor} text-sm font-semibold rounded-full mb-4`}>
                  {advantage.tag}
                </span>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {advantage.title}
                </h3>

                {/* Pain Point */}
                <div className="bg-red-50 border-l-4 border-red-400 p-5 mb-6 rounded-r-lg">
                  <div className="flex items-start">
                    <i className="ri-error-warning-line text-red-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                    <div>
                      <div className="text-sm font-semibold text-red-800 mb-1">{advantage.painPointLabel}</div>
                      <p className="text-sm text-red-700 leading-relaxed">{advantage.painPoint}</p>
                    </div>
                  </div>
                </div>

                {/* Solution */}
                <div className="bg-green-50 border-l-4 border-green-400 p-5 rounded-r-lg">
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-line text-green-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                    <div>
                      <div className="text-sm font-semibold text-green-800 mb-1">{advantage.solutionLabel}</div>
                      <p className="text-sm text-green-700 leading-relaxed">{advantage.solution}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Image */}
              <div className={advantages[index].imagePosition === 'left' ? 'md:order-1' : ''}>
                <div className="relative rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={advantages[index].image}
                    alt={advantage.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}